module.exports = __webpack_public_path__ + "static/media/rotasFavoritas.46b9b968.svg";